import HomeTabs from "../../molecules/homeTabs/HomeTabs";
import HomePageHeading from "../../molecules/homePageHeading/homePageHeading";
import CardsCarousel from "../../molecules/cardsCarousel/CardsCarousel";
import {
  Router,
  useRouter,
  Container,
  CustomContainer,
} from "../../atoms/DependencyHelper";
import ajaxService from "../../../utils/ajaxServices";
import styles from "./productCatalog.module.scss";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import ProductCarousel from "../../molecules/ProductCarousel/ProductCarousel";
import { checkIsFinalPriceReq, checkIsLowStock, checkIsOutOfStock, getAmountOffValue, getFinalPrice, getPercentOffValue, getPromotionLabel, getPromotionVariant, getRegularPrice, getRequestBody, requestType } from "../../../utils/helperServices";
import * as Analytics from "../../../services/analyticsUtag";
import ProductCards from "../../molecules/ProductCards/ProductCards";
import ProductGridList from "../../molecules/ProductGridList/ProductGridList";

const config = require("../../../config/index");
const env = config.env;
const server = config.envConfigs[env].server;
const url = `${server}${config.graphqlUrl}`;

const ProductCatalog = ({ component, analyticsData }) => {
  const tempKeys = component?.productCategory;
  const totalKeys = tempKeys.length;
  const [tabsToRender, pushTabs] = useState([]);
  const syncArray = [];

  const redirectToProducts = () => {
    const viewData = Analytics.getUtagData([
      "page_name",
      "page_channel",
      "page_master_tab",
      "visitor_login_status",
      "visitor_msisdn_hash",
      "visitor_customer_id",
      "visitor_id_hash",
      "visitor_subscription_type",
      "page_site_section_lvl_1",
      "page_site_section_lvl_2",
      "page_site_section_lvl_3",
      "page_site_section_lvl_4"
    ]);
    Analytics.link({
      link_type: "o",
      link_name: `${viewData?.page_name}: all products: ${component.title}`,
      ...viewData
    })
  };

  const apiMethod = component.API.method
    ? component.API.method
    : component.API.single.method;

  const body = getRequestBody(component.API);

  const requestBodyUrl = apiMethod === "GET" ? body.replace(url, "") : body;

  useEffect(() => {
    async function generateTabs() {
      if (Object.keys(component.API).includes("all")) {
        const newArray = tempKeys.map((item) => item.productSku);
        const newKeys = [].concat.apply([], newArray);
        const allkeys = newKeys.join('","');
        const requestBody =
          requestType(component.API.all).replace("<productSku>", allkeys) || "";
        generateData(requestBody, component.API.all.method, "All",newKeys);
      }
      for (let i = 0; i < totalKeys; i++) {
        let allkeys = tempKeys[i].productSku.join('","');
        const requestBody =
          requestBodyUrl.replace("<productSku>", allkeys) || "";
        generateData(requestBody, apiMethod, tempKeys[i].tab,tempKeys[i].productSku);
      }
    }
    if (component.displayStyle !== "Grid") {
      generateTabs();
    }
  }, []);

  useEffect(()=>{
    if(component && component.callToActionUrl) {
      let url = component.callToActionUrl;
      if (component.callToActionUrl.includes("internal:")) {
        url = component.callToActionUrl.split("internal:")[1];
      }
      Router.prefetch(url);
    }
  },[])

  const generateData = async (requestBody, method, tempkey, allSku) => {
    try {
      const results =
        method === "GET"
          ? await ajaxService.fetchGraphQLGetRequest(requestBody.split("=")[1])
          : await ajaxService.fetchGraphQLPOSTRequest(requestBody);
          const sortedArray = [];
          allSku.forEach((item) =>
          results?.products?.items.find((category) => {
          if (category.sku === item) {
          sortedArray.push(category);
          }
          })
          );
      if (!Object.keys(component.productCategory[0]).includes("tab")) {
        syncArray.push(sortedArray);
      } else if (component.displayStyle === "Carousel" || sortedArray.length > 5) {
        syncArray.push({
          title: tempkey,
          component: (
            <div>
              <Container className={`text-center ${styles["product-carousel-container"]}`}>
                <ProductCarousel
                  ProductCarouselData={sortedArray}
                  width="100%"
                  img_width="11.25rem"
                  img_height="11.25rem"
                  width_mobile="10.375rem"
                  img_width_mobile="8.375rem"
                  img_height_mobile="8.375rem"
                  alignment={component?.heading_position}
                  endsIn={component?.endingSoonColor}
                  availableIn={component?.comingSoonColor}
                  tabName={tempkey}
                  carouselId="shop-product-carousel"
                />
              </Container>
              <Container className='text-center'>
                <CTAButton
                  className={`${styles["shop-all-big"]}`}
                  handleClick={redirectToProducts}
                  isOpenNewTab={component?.isOpenNewTab}
                  url={component.callToActionUrl}
                  variant="outline grey"
                  id={`${component.buttonLabel}-btn`}
                >
                  {component.buttonLabel}
                </CTAButton>
              </Container>
            </div>
          ),
        });
      } else {
        syncArray.push({
          title: tempkey,
          component: (
            <Container className="text-center">
              <CardsCarousel cards={sortedArray} alignment={component?.heading_position} tabName={tempkey}/>
              <CTAButton
                className={`${styles["shop-all"]}`}
                handleClick={redirectToProducts}
                isOpenNewTab={component?.isOpenNewTab}
                url={component.callToActionUrl}
                variant="outline black"
                id={`${component.buttonLabel}-btn`}
              >
                {component.buttonLabel}
              </CTAButton>
            </Container>
          ),
        });
      }
    } finally {
      let updatedArray = [];
      if (
        Object.keys(component.API).includes("all") ? totalKeys + 1 : totalKeys
      ) {
        if (!Object.keys(component.productCategory[0]).includes("tab")) {
          updatedArray = syncArray;
        } else {
          tempKeys.forEach((category) => {
            const newItem = syncArray.filter((item) => {
              if (category.tab === item.title) {
                updatedArray.push(item);
              }
            });
          });
        }
      }
      if (
        Object.keys(component.API).includes("all") &&
        syncArray.filter((item) => item.title === "All").length
      ) {
        updatedArray.unshift(
          syncArray.filter((item) => item.title === "All")[0]
        );
      }
      if (
        updatedArray.length ===
        (Object.keys(component.API).includes("all") ? totalKeys + 1 : totalKeys)
      ) {
        pushTabs(updatedArray);
      }
    }
  };

  return (
    <>
      <HomePageHeading
        text={component.title}
        secondaryText={component?.description || component.title}
        alignment={component?.heading_position || "LEFT"}
        textClassName={
          component.displayStyle === "Carousel"
            ? styles["heading-carousel"]
            : `explore-our-section ${styles["heading"]}`
        }
        isRegularFont
        mainHeadingRequired={component.description}
        id={component.id ? component.id:'product-catalog'}
      />
      {!Object.keys(component.productCategory[0]).includes("tab") &&
        tabsToRender.length > 0 && (
          <CustomContainer className="pt-l">
            <ProductCarousel
              ProductCarouselData={tabsToRender[0]}
              hideButtons={component.displayStyle === "Grid"}
              width="100%"
              img_width="11.25rem"
              img_height="11.25rem"
              width_mobile="10.375rem"
              img_width_mobile="8.375rem"
              img_height_mobile="8.375rem"
              alignment={component?.heading_position}
              isDeal={false}
            />
          </CustomContainer>
        )}
         {component.displayStyle === "Grid" && (
          <Container className="pb-xs">
            <ProductGridList
              width="315px"
              img_width="11.25rem"
              img_height="11.25rem"
              width_mobile="12.375rem"
              img_width_mobile="8.375rem"
              img_height_mobile="8.375rem"
              navigateTo={redirectToProducts}
              component={component}
            />
          </Container>
        )}
      {tabsToRender.length > 0 && (
        <HomeTabs
          tabsContent={tabsToRender}
          variant={component.tabStyle ? component.tabStyle : "line-secondary"}
          className="product_catalog"
          alignment={component?.heading_position}
          analytics={{link_name: `${analyticsData?.page_name}: product: ${component.title}:`}}
        ></HomeTabs>
      )}
    </>
  );
};
ProductCatalog.propTypes = {
  component: PropTypes.any,
  analyticsData: PropTypes.any,
};

ProductCatalog.defaultProps = {
  component: {},
  analyticsData: {},
};
export default ProductCatalog;
